import React from 'react'
import cn from 'classnames'

import './FormGroup.less'

type FormGroupProps = {
  error?: boolean
  success?: boolean
  className?: string
  children?: React.ReactNode
}

function FormGroup({ error, success, className, children }: FormGroupProps) {
  return (
    <div className={cn('form-group', { 'has-error': error, 'has-success': success }, className)}>
      {children}
    </div>
  )
}

export default FormGroup
